module.exports = __webpack_public_path__ + "img/Contact.40b958b7.png";